import React from 'react';
import { EditableColumnType } from 'components/CustomTable/CustomTable';
import { PlusOutlined } from '@ant-design/icons';
import { DataType } from 'store/ducks/DataEntry/Branch/types';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { IArticle8Types } from 'store/ducks/DataManagement/Article8AndICTSystem/types';
import * as Styled from '../Tables/DataEntry/DataEntry.styled';

export const getArticle8Columns = (
  handleDateChange: (key: number, field: string, value: string) => void,
  handleAddRow: (record: { key: React.Key }, index: number) => void,
  handleRemoveRow: (key: number) => void,
  handleInactivate: (record: IArticle8Types) => void,
  t: (key: string) => string,
): EditableColumnType[] => [
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('ARTICLE8.NAME')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'name',
    editable: true,
    fixed: 'left',
  },
  {
    title: <>{t('ARTICLE8.START_DATE')}</>,
    dataIndex: 'start_date',
    editable: false,
    render: (text: string, record: DataType) => (
      <Styled.RelativeDateWrapper>
        <DatePicker
          value={text ? dayjs(text) : null}
          format="YYYY-MM-DD"
          onClick={(e) => e.stopPropagation()}
          onChange={(date) => {
            const formattedDateString = date
              ? dayjs(date).format('YYYY-MM-DD')
              : '1900-01-01';
            handleDateChange(record.key, 'start_date', formattedDateString);
          }}
        />
      </Styled.RelativeDateWrapper>
    ),
  },
  {
    title: <>{t('ARTICLE8.END_DATE')}</>,
    dataIndex: 'end_date',
    editable: false,
    render: (text: string, record: DataType) => (
      <Styled.RelativeDateWrapper>
        <DatePicker
          value={text ? dayjs(text) : null}
          format="YYYY-MM-DD"
          onClick={(e) => e.stopPropagation()}
          onChange={(date) => {
            const formattedDateString = date
              ? dayjs(date).format('YYYY-MM-DD')
              : '9999-01-01';
            handleDateChange(record.key, 'end_date', formattedDateString);
          }}
        />
      </Styled.RelativeDateWrapper>
    ),
  },
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('ARTICLE8.DESCRIPTION')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'description',
    editable: true,
  },
  {
    title: t('GENERAL.ACTIONS'),
    key: 'actions',
    width: 150,
    render: (_: any, record) => (
      <>
        {record.isNew ? (
          <Button danger onClick={() => handleRemoveRow(record.key)}>
            {t('GENERAL.REMOVE')}
          </Button>
        ) : (
          <Button
            danger
            onClick={() => handleInactivate(record as IArticle8Types)}
          >
            {t('GENERAL.SOFT_DELETE')}
          </Button>
        )}
      </>
    ),
  },
];
